import {app} from "../app";
import {IThemerService} from "../services/ThemerService";

class ThemerStyleDirective implements ng.IDirective {

    private themerService:IThemerService;
    private element:ng.IAugmentedJQuery;
    private attrs:ng.IAttributes;

    restrict = 'E';
    replace = true;
    scope = {};

    constructor(ThemerService:IThemerService) {
        this.themerService = ThemerService;

        this.themerService.onChange(() => {
            this.generateStyles();
        });
    }

    link = (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ctrl: any) => {
        this.element = element;
        this.attrs = attrs;

        this.generateStyles();
    };

    template = '<style></style>';

    private generateStyles() {
        var html = '';
        for (let selector of this.themerService.getSelectors()) {
            let state = selector.state ? ':' + selector.state : '';
            let className = 'themer' + selector.selector.charAt(0).toUpperCase() + selector.selector.slice(1);
            html += '.' + className + state + ' {';
            for (let declaration of selector.declarations) {
                html += ' ' + declaration.property + ': ' + declaration.value + ' !important; ';
            }
            html += '} ';
        }
        this.element.html(html);
    }

    static factory(): ng.IDirectiveFactory {
        const directive = (ThemerService:IThemerService) => new this(ThemerService);
        directive.$inject = ['ThemerService'];
        return directive;
    }

}

app.directive('themerStyle', ThemerStyleDirective.factory());